import React from 'react';
import './BrandLogo.css';

export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL}/FTMX%20logo%20PNG.png`;

const BrandLogo = ({ className = '', height = 36 }) => (
  <span
    className={`brand-logo-text ${className}`.trim()}
    style={{ fontSize: `${Math.round(height * 0.58)}px` }}
    aria-label="FTMX"
  >
    FTMX
  </span>
);

export default BrandLogo;
